module.exports = __webpack_public_path__ + "img/bottombgc.e477ff48.png";